// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 15:21:14
import { ApplicationIcons_abstract } from './../../abstract/SagaSchema/ListObjects/ApplicationIcons_abstract';
export class ApplicationIcons extends ApplicationIcons_abstract {}
